import TextInputField from 'components/fields/text-input-field/text-input-field.component'
import FormTwoColumnLayout from 'layouts/form-two-column-layout/form-two-column-layout'
import FormSingleColumnLayout from 'layouts/form-single-column-layout/form-single-column-layout'
import DatePickerField from 'components/fields/date-range-picker-field/date-range-picker-field.component'
import TimeInputField from 'components/fields/time-input-field/time-input-field.component'
import { LoadConfirmFormContainer } from 'components/forms/forms.styles'
import { useDeliveryDateTimeSync } from '../utils/use-delivery-datetime-sync'
import { LoadConfirmationStopActions } from '../components/load-confirmation-stop-actions'

type LoadConfirmationDeliveryFormProps = {
  stopIndex: number
  hasTransportStops: boolean
  onChangePickupDelivery: () => void
}

export function LoadConfirmationDeliveryForm({
  stopIndex,
  hasTransportStops,
  onChangePickupDelivery,
}: LoadConfirmationDeliveryFormProps) {
  const { startTimeOnlyField, endTimeOnlyField, basePath } =
    useDeliveryDateTimeSync(stopIndex)

  return (
    <LoadConfirmationStopActions
      hasTransportStops={hasTransportStops}
      onAddPickupDelivery={onChangePickupDelivery}
      onChangePickupDelivery={onChangePickupDelivery}
    >
      <LoadConfirmFormContainer
        container
        spacing={2}
        $compact
        data-testid="LoadConfirmation.Delivery.Form"
        sx={{ px: 0, pt: 0 }}
      >
        <FormTwoColumnLayout>
          <DatePickerField
            label="Start Delivery Date"
            name={`${basePath}.startTime`}
            highlight
            hideIcon
          />
          <DatePickerField
            label="End Delivery Date"
            name={`${basePath}.endTime`}
            highlight
            hideIcon
          />
          <TimeInputField
            label="Start Delivery Time"
            name={startTimeOnlyField}
            highlight
            hideSelectIcon
          />
          <TimeInputField
            label="End Delivery Time"
            name={endTimeOnlyField}
            highlight
            hideSelectIcon
          />
        </FormTwoColumnLayout>

        <FormSingleColumnLayout>
          <TextInputField
            label="Delivery Company Name"
            name={`${basePath}.name`}
            highlight
          />
          <TextInputField
            label="Delivery Company Address"
            name={`${basePath}.address`}
            highlight
          />
          <TextInputField
            label="Shipment Notes"
            name={`${basePath}.notes`}
            multiline
            minRows={3}
          />
        </FormSingleColumnLayout>
      </LoadConfirmFormContainer>
    </LoadConfirmationStopActions>
  )
}
